export default "__VITE_ASSET__QxVQyKMj__"